/**
 * 次の即時のイベントループのタイミングまで待機します。
 */
export function waitImmediate(): Promise<void> {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve()
    }, 0)
  })
}
